import { useEffect, useState } from "react";

const initialState = {
    fechaVencimiento: "",
    montoProgramado: "",
};

export default function EditarCuotaForm({ cuota, onClose, onSave }) {
    const [form, setForm] = useState(initialState);

    useEffect(() => {
        if (cuota) {
            setForm({
                fechaVencimiento: cuota.fechaVencimiento || "",
                montoProgramado: cuota.montoProgramado || "",
            });
        }
    }, [cuota]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        await onSave({
            fechaVencimiento: form.fechaVencimiento,
            montoProgramado: Number(form.montoProgramado || 0),
        });
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-card">
                <div className="modal-header">
                    <h3>Editar cuota #{cuota?.numeroCuota}</h3>
                    <button type="button" onClick={onClose}>X</button>
                </div>

                <form className="grid-form" onSubmit={handleSubmit}>
                    <div>
                        <label>Número de cuota</label>
                        <input value={cuota?.numeroCuota || ""} disabled />
                    </div>

                    <div>
                        <label>Fecha de vencimiento</label>
                        <input
                            name="fechaVencimiento"
                            type="date"
                            value={form.fechaVencimiento}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Monto programado</label>
                        <input
                            name="montoProgramado"
                            type="number"
                            step="0.01"
                            value={form.montoProgramado}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="form-actions full-width">
                        <button type="button" onClick={onClose}>Cancelar</button>
                        <button type="submit">Guardar cambios</button>
                    </div>
                </form>
            </div>
        </div>
    );
}